export default __webpack_public_path__ + "static/media/pivo.62feb330.png";